import React from 'react'
import { t } from 'ttag'
import * as Sentry from '@sentry/browser'

import { setReloadFlag } from './miniHub'

import * as h2Api from '../h2Api'

export const FILE_WIZARD_LIST_FILES = 'FILE_WIZARD_LIST_FILES'
export const FILE_WIZARD_ADD_FILE = 'FILE_WIZARD_ADD_FILE'
export const FILE_WIZARD_FILE_UPLOAD_START = 'FILE_WIZARD_FILE_UPLOAD_START'
export const FILE_WIZARD_FILE_UPLOAD = 'FILE_WIZARD_FILE_UPLOAD'
export const FILE_WIZARD_OPEN = 'FILE_WIZARD_OPEN'
export const FILE_WIZARD_SETIMAGE = 'FILE_WIZARD_SETIMAGE'
export const FILE_WIZARD_OPEN_CLOSE = 'FILE_WIZARD_OPEN_CLOSE'
export const FILE_WIZARD_FIELD_CHANGE = 'FILE_WIZARD_FIELD_CHANGE'
export const FILE_WIZARD_FILE_DELETE = 'FILE_WIZARD_FILE_DELETE'
export const FILE_WIZARD_DATE_SORT = 'FILE_WIZARD_DATE_SORT'
export const FILE_WIZARD_UPDATE_TAG = 'FILE_WIZARD_UPDATE_TAG'
export const FILE_WIZARD_LIST_TAGS = 'FILE_WIZARD_LIST_TAGS'
export const FILE_WIZARD_TAG_FILE = 'FILE_WIZARD_TAG_FILE'
export const FILE_WIZARD_TAG_FILE_DELETE = 'FILE_WIZARD_TAG_FILE_DELETE'
export const FILE_WIZARD_RENAME = 'FILE_WIZARD_RENAME'

const isProfile = o => {
  // console.log(o)
  return o && o.hasOwnProperty('type') && o.type != 'user'
}

export const listFiles = d => {
  const url = isProfile(d)
    ? `/profiles/${d.type}/${d.id}/files`
    : d && d.id
    ? `/api/v2/management/users/files/list/${d.id}`
    : `/api/v2/files`

  return h2Api.post(url, {})({ type: FILE_WIZARD_LIST_FILES })
}

export const listFilesWithRestriction = type => {
  const url = `/user/files/list?type=${type}`

  return h2Api.get(url)({ type: FILE_WIZARD_LIST_FILES })
}

export const listTags = () => {
  return h2Api.get(`/user/tags`)({ type: FILE_WIZARD_LIST_TAGS })
}

export const renameFile = (fileJson, d) => dispatch => {
  if (isProfile(d)) {
    return dispatch(
      h2Api.put(`/profiles/${d.type}/${d.id}/files/${fileJson.id}/rename`, {
        name: fileJson.fileName
      })({ type: FILE_WIZARD_RENAME })
    )
  }

  return dispatch(
    h2Api.put(`/user/file/${fileJson.id}/rename`, {
      name: fileJson.fileName
    })({ type: FILE_WIZARD_RENAME })
  )
}

export const uploadFile = (input, d) => dispatch => {
  dispatch({ type: FILE_WIZARD_FILE_UPLOAD_START })
  //console.log(input.files)
  const data = new FormData()

  Array.from(input).forEach(f => {
    data.append('file', f)
  })

  const url = isProfile(d)
    ? `/profiles/${d.type}/${d.id}/upload`
    : d && d.id
    ? `/api/v2/management/users/files/${d.id}`
    : `/api/v2/files`

  return dispatch(
    h2Api.postFile(
      url,
      data
    )({
      type: FILE_WIZARD_FILE_UPLOAD
    })
  )
}

export const fileDateSort = () => dispatch => {
  dispatch({ type: FILE_WIZARD_DATE_SORT })
}

export const deleteFile = (input, d) => (dispatch, getState) => {
  const url = isProfile(d)
    ? `/profiles/${d.type}/${d.id}/files/${input.id}`
    : d && d.id
    ? `/api/v2/management/users/files/${d.id}/${input.id}`
    : `/api/v2/files/${input.id}`

  h2Api
    .doDelete(url)({
      type: FILE_WIZARD_FILE_DELETE,
      fileId: input.id
    })(dispatch)
    .then(function () {
      try {
        const ud = getState().miniHub.userData
        const rslt = ud && ud.result
        const itms = (rslt && rslt.activity) || []

        if (itms.filter(f => f.type == 'files' && f.id == input.id).length > 0) {
          dispatch(setReloadFlag(true))
        }
      } catch (e) {
        console.log(e)

        if (dynamicValues.isProduction) {
          Sentry.captureException(e)
        }
      }
    })
}

export const useImage = (f, useType, d) => dispatch => {
  console.log(d)
  const action = useType == 1 ? 'masthead' : useType == 3 ? 'thumb' : 'logo'
  const url = isProfile(d)
    ? `/profiles/${d.type}/${d.id}/${action}`
    : d && d.hasOwnProperty('id')
    ? `/user/${d.id}/files/${action}`
    : `/user/files/${action}`

  h2Api
    .post(url, {
      imageId: f.id
    })({
      type: FILE_WIZARD_SETIMAGE
    })(dispatch)
    .then(() => {
      window.location.reload()
    })
}

export const tagFile = (fileId, tag) => dispatch => {
  if (tag.hasOwnProperty('id')) {
    return dispatch(
      h2Api.put(
        `/user/file/${fileId}/tag/${tag.id}`,
        {}
      )({
        type: FILE_WIZARD_TAG_FILE,
        fileId,
        newTag: false,
        tag
      })
    )
  }

  return dispatch(
    h2Api.post(`/user/file/${fileId}/tag`, {
      tag: tag.name
    })({
      type: FILE_WIZARD_TAG_FILE,
      fileId,
      newTag: true,
      tag
    })
  )
}

export const deleteFileTag = (fileId, tag) => dispatch => {
  return dispatch(
    h2Api.doDelete(`/user/file/${fileId}/tag/${tag.id}`)({
      type: FILE_WIZARD_TAG_FILE_DELETE,
      fileId,
      tagId: tag.id
    })
  )
}

export const deleteImage = (useType, d) => dispatch => {
  const action = useType == 1 ? 'masthead' : useType == 3 ? 'thumb' : 'logo'
  const url = isProfile(d)
    ? `/profiles/${d.type}/${d.id}/${action}`
    : `/user/files/${action}`

  h2Api
    .doDelete(url)({
      type: FILE_WIZARD_SETIMAGE
    })(dispatch)
    .then(() => {
      window.location.reload()
    })
}

export const fileSize = f => {
  return f.size.toFixed(0).replace(/./g, function (c, i, a) {
    return i && c !== '.' && (a.length - i) % 3 === 0 ? `,${c}` : c
  })
}

export const mimeToHumanString = mimeType => {
  if (mimeType.includes('image/')) {
    return t`Image`
  }

  if (mimeType === 'application/pdf') {
    return `PDF`
  }

  if (
    mimeType === 'application/vnd.ms-excel' ||
    mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ) {
    return `MS Excel`
  }

  if (
    mimeType ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    mimeType === 'application/msword'
  ) {
    return `MS Word`
  }

  if (
    mimeType ===
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
    mimeType === 'application/vnd.ms-powerpoint'
  ) {
    return `Powerpoint`
  }

  if (mimeType === 'application/zip') {
    return `ZIP Archive`
  }

  return mimeType
}

export const openFileWizardModal = (d, t, fullScreen) => dispatch => {
  return dispatch(listFiles(d))
    .then(() =>
      dispatch({
        type: FILE_WIZARD_OPEN_CLOSE,
        isOpened: true,
        fullScreen: !!fullScreen,
        profileInfo: d,
        profileType: t
      })
    )
    .then(() => dispatch(listTags()))
}

export const closeContentWizard = () => dispatch =>
  dispatch({ type: FILE_WIZARD_OPEN_CLOSE, isOpened: false })

export const onFieldChange = (storeKeyId, isRoot, value) => dispatch => {
  dispatch({ type: FILE_WIZARD_FIELD_CHANGE, storeKeyId, isRoot, value })
}

export const addFile = file => dispatch => dispatch({ type: FILE_WIZARD_ADD_FILE, file })
